<template>
  <div class="div-container">
    <v-app-bar
      app
      color="blue"
      dark
      clipped-left
    >
      <v-spacer />
      <div>Quanticy</div>
      <v-spacer />
    </v-app-bar>
    <v-container fluid>
      <v-row align="center">
        <v-col
          md="4"
          offset-md="4"
          align-self="end"
        >
          <h2>Login</h2>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="performLogin()"
          >
            <v-text-field
              id="login-username"
              v-model="login.username"
              class="md alone"
              :rules="notEmptyRule"
              label="Benutzername"
              required
            />
            <v-text-field
              id="login-password"
              v-model="login.password"
              class="md alone"
              :rules="notEmptyRule"
              label="Passwort"
              required
              :append-icon="pwVisability ? 'fa-eye' : 'fa-eye-slash'"
              :type="pwVisability ? 'password' : 'text'"
              @click:append="() => (pwVisability = !pwVisability)"
            />
            <v-row
              max-width="auto"
              justify="end"
              style="margin: 0"
            >
              <reset-password-dialog />
            </v-row>
            <v-row :justify="'space-between'">
              <v-col
                md="2"
                md-offset="10"
              >
                <v-btn
                  text
                  type="submit"
                >
                  <v-icon>fa-sign-in-alt</v-icon>
                </v-btn>
              </v-col>
              <v-col
                md="2"
                md-offset="10"
                class="d-flex justify-end"
              >
                <RegisterUserDialog />
              </v-col>
            </v-row>
            <div
              v-if="showLoginNotPossible"
              id="login-error"
            >
              Zugriff verweigert. Bitte überprüfen Sie Ihren Benutzernamen und
              das Passwort und versuchen Sie es erneut.
            </div> 
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <Footer />
    <v-dialog
      v-model="showLicenseExpired"
      persistent
      max-width="700px"
    >
      <v-card>
        <v-card-title>
          <v-row>
            <v-col cols="auto">
              <h3>Lizenz erneuern</h3>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
              <v-btn
                icon
                @click="showLicenseExpired = false"
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-alert
            elevation="2"
            border="top"
            colored-border
            type="info"
            class="mt-3"
          >
            Vielen Dank für die Nutzung von Quanticy!<br>
            <br>
            Ihre Lizenz ist zum {{ licenseExpiredDate }} abgelaufen.
            Wenn Sie eine Erneuerung Ihrer Lizenz wünschen, kontaktieren Sie uns unter
            <a href="mailto:quanticy@spicetech.de">quanticy@spicetech.de</a>.
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RegisterUserDialog from "@/components/dialogs/RegisterUserDialog.vue";
import Footer from "@/shared/Footer";

import { mapMutations } from "vuex";
import ResetPasswordDialog from '../components/dialogs/ResetPasswordDialog.vue';

export default {
  components: { Footer, RegisterUserDialog, ResetPasswordDialog },
  data() {
    return {
      pwVisability: true,
      login: { username: "", password: "" },
      showLoginNotPossible: false,
      showLicenseExpired: false,
      licenseExpiredDate: null,
      valid: false,
      notEmptyRule: [v => !!v || "Required field"],
      urlRule: [
        v =>
          /^$|https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/.test(
            v
          ) || "Url is incomplete"
      ],
      emailRule: [
        v =>
          /^$|^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail address is incomplete"
      ]
    };
  },
  beforeCreate() {
    $api
      .get("auth/checklogin")
      .then(res => {
        if (res.data.authenticated === true) {
          console.log("User has been authenticated before.");
          this.setUser(res.data);
          // this.$store.commit("setCurrentClientId", res.data.client_id);
          this.$router.push("/main").catch(() => {});
        } else {
          window.EventBus.$emit("NotAuthenticated");
        }
      })
      .catch(err => {
        console.error(err);
        window.EventBus.$emit("NotAuthenticated");
      });
  },
  mounted() {
    window.EventBus.$on("licenseExpired", (license) => {
      this.licenseExpiredDate = new Date(license.end).toLocaleDateString('de-DE');
      this.showLicenseExpired = true;
    })
  },
  methods: {
    ...mapMutations(["setUser"]),
    performLogin() {
      let licenseExpired = false;
      let license = null;
      $api
        .post("auth/login", this.login)
        .then(res => {
          if (res.data.authenticated === true) {
            this.showLoginNotPossible = false;
            this.setUser(res.data.user);
            // this.$store.commit("setCurrentClientId", res.data.client_id);
            this.$router.push("/main").catch(() => {});
          } else {
            licenseExpired = !!res.data.licenseExpired;
            license = res.data.license
            throw "res.data.authenticated not true";
          }
        })
        .catch(() => {
          if (licenseExpired) {
            window.EventBus.$emit("licenseExpired", license);
          } else {
            this.showLoginNotPossible = true;
            window.EventBus.$emit("NotAuthenticated");
          }
        });
    }
  }
};
</script>

<style scoped>
#login-error {
  font-size: 12px;
  color: red;
}
</style>
